import React from 'react';
import ChangePageTitle from '../components/change-title-page';
import Menu_content from '../components/components-menu';

function Menu(){

    return(
        <>
            <ChangePageTitle pageTitle="منو | رستوران باغبان" />
            <Menu_content />
        </>
    );

}

export default Menu;